import { debounce } from "../utility/limiters";


export default function( slider ) {
    function updateHeight() {
        requestAnimationFrame( () => {
            slider.container.style.height =
                slider.slides[slider.track.details.rel].offsetHeight + "px";
        })
    }
    slider.on( "created", updateHeight );
    slider.on( "slideChanged", debounce(updateHeight, 100) );
};